module.exports = __webpack_public_path__ + "img/b2b-img-refer-top-2x.893781a7.png";